module.exports = __webpack_public_path__ + "img/P2PGlobal.6d26271b.png";